import Vue from "vue";

const END_POINT = "/api/checklists";

class ChecklistService {
  // Get paginated checklists by center ID
  static getChecklists(page = 0, size = 10, centerId, sort) {
    // Constructing query parameters
    const params = {
      page,
      size,
      centerId, // Assuming centerId is optional; if not provided, it will not be included in the query
      sort,
    };
    return Vue.axios.get(`${END_POINT}`, { params });
  }

  // Create a new checklist
  static createChecklist(checklistDto) {
    return Vue.axios.post(`${END_POINT}`, checklistDto);
  }

  // Update an existing checklist
  static updateChecklist(id, checklistDto) {
    return Vue.axios.put(`${END_POINT}/${id}`, checklistDto);
  }

  // Get a checklist by its ID
  static getChecklistById(id) {
    return Vue.axios.get(`${END_POINT}/${id}`);
  }

  // Delete a checklist
  static deleteChecklist(id) {
    return Vue.axios.delete(`${END_POINT}/${id}`);
  }

  // Create a new checklist item
  static createChecklistItem(checklistItemDto) {
    return Vue.axios.post(`${END_POINT}/items`, checklistItemDto);
  }

  // Update an existing checklist item
  static updateChecklistItem(itemId, checklistItemDto) {
    return Vue.axios.put(`${END_POINT}/items/${itemId}`, checklistItemDto);
  }

  // Get a checklist item by its ID
  static getChecklistItemById(itemId) {
    return Vue.axios.get(`${END_POINT}/items/${itemId}`);
  }

  // Delete a checklist item
  static deleteChecklistItem(itemId) {
    return Vue.axios.delete(`${END_POINT}/items/${itemId}`);
  }

  // Find all checklist items by checklist ID
  static findAllChecklistItemsByChecklistId(checklistId) {
    return Vue.axios.get(`${END_POINT}/items/by-checklist/${checklistId}`);
  }
}

export default ChecklistService;
